import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SecondaryHeader from "components/SecondaryHeader";
import SearchHeader from "components/SearchHeader";
import Footer from "components/Footer";

import styles from "assets/jss/basestyle";
import PrimaryHeaderCopy from "components/new/PrimaryHeaderCopy";
import IndicadoresHeader from "components/new/IndicadoresHeader";

const useStyles = makeStyles(styles);

export default function NewBaseScreen(props) {
    const { /*navBars, breadCrumbsRoutes,*/ bodyColor, primaryHeader, indicadoresHeader, secondaryHeader, searchHeader } = props;
    const classes = useStyles();

    /*function handleClick(event) {
        event.preventDefault();
    }*/
    return (
        <div style={{ backgroundColor: bodyColor ? bodyColor : '#FFF' }} >
            {primaryHeader ? <PrimaryHeaderCopy /> : null}
            {indicadoresHeader ? <IndicadoresHeader /> : null}
            {secondaryHeader ? <SecondaryHeader /> : null}
            {searchHeader ? <SearchHeader /> : null}
            <div className={classes.wrapper} >
                {props.children}
                <Footer />
            </div>
        </div>
    )
}
